import { useCallback, useEffect, useState } from 'react';
import './App.scss';
import useAppStore from 'store/store';
import PageIndex from 'pages';
import Loading from 'modules/Loading/Loading';
import PageUnknown from 'pages/unknown';
import useFocus from 'hooks/useFocus';
import LanguageSelect from 'modules/LanguageSelect/LanguageSelect';

export const App = () => {

	// Keep for store updating
	useFocus();

	const setConfig = useAppStore((state) => state.setConfig);
	const config = useAppStore((state) => state.config);
	const inDevelopment = useAppStore((state) => state.inDevelopment);

	const [ error, setError ] = useState( false );

	useEffect(() => {
		// Reset error state
		setError( false );

        // Check if there already is a session ID in local storage
        // const sessionId = localStorage.getItem('sessionId');
		// if (sessionId) {
		// 	// Set the session ID in the store
		// 	setSessionId(sessionId);
		// }

		// In development we use a local server
		if( inDevelopment ) {
			setConfig({
				serverUrl: 'http://localhost:4000',
				// serverUrl: 'http://macbook-pro-van-maikel-2:4000',
			})
			return
		}

		// Fetch the config.json from the app
		fetch('/config.json')
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}

				return response.json();
			})
			.then((data) => {
				setConfig(data);
			})
			.catch((error) => {
				// console.error('There was a problem with the fetch operation:', error);
				setError( true );
			});
	}, []);

	console.log('testy5', error, config );

	if ( error ) {
		return <>
			<PageUnknown />

			<LanguageSelect />
		</>;
	}
	
	if( !config || Object.keys(config).length === 0 ) {
		return <Loading />;
	}

	return <>
		<PageIndex />

		<LanguageSelect />
	</>;
}